import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  padding: ${themeGet('spacing.xl')};
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden auto;
`;
